import C from "../../../Constants";

const CustomTaskEdit = (() => {
  // 入力フィールド設定
  // 開始日
  const startDateField = {
    type: "datetime",
    label: "開始",
    name: "startDate",
    cls: "b-start-date",
    flex: "1 0 100%",
    weight: 200,
  };

  // 終了日
  const endDateField = {
    type: "datetime",
    label: "終了",
    name: "endDate",
    cls: "b-end-date",
    flex: "1 0 100%",
    weight: 201,
  };

  // 下船中様態・休暇希望の備考
  const remarksField = {
    weight: 300,
    label: "備考",
    type: "textfield",
    inputAttributes: {
      tag: "textarea",
    },
    cls: "b-taskeditor-notes-field",
    name: "remarks",
  };

  // 休暇希望の優先度ラジオボタン
  const priorityField = {
    type: "radiogroup",
    name: "priority",
    label: "優先度",
    labelWidth: "6em",
    flex: "0 0 100%",
    weight: 202, // Place before resources field
    options: C.DAY_OFF_REQUEST_PRIORITY_NAME,
  };

  // 下船中様態の種類セレクトボックス
  const offBoadStatusCombo = {
    type: "combo",
    name: "enterprise_manning_status_id",
    label: "下船期間種別",
    weight: 100,

    editable: true,
    disabled: false,
    items: [],
  };

  const vesselCombo = {
    type: "combo",
    name: "enterprise_manning_vessel_id",
    label: "船名",
    weight: 100,
    editable: true,
    disabled: false,
    items: [],
  };

  const roleCombo = {
    type: "combo",
    name: "enterprise_manning_vessel_role_position_id",
    label: "役職",
    weight: 100,
    editable: true,
    disabled: false,
    items: [],
  };

  const buildCustomTaskEdit = selectableAhoreStausList => {
    offBoadStatusCombo.items = selectableAhoreStausList.map(status => ({
      value: status.id,
      text: status.name,
    }));

    return {
      editorConfig: {
        bbar: {
          items: {
            deleteButton: false,
          },
        },
      },
      // イベント編集中はhasChangesイベントを無効にする
      suspendHasChangesEvent: true,

      // 全てのタブを無効にする。
      items: {
        generalTab: false,
        recurrenceTab: false,
        predecessorsTab: false,
        successorsTab: false,
        advancedTab: false,
        notesTab: false,
        // 下船中様態タブ
        offboardTab: {
          title: "",
          items: {
            offBoadStatusCombo,
            startDateField,
            endDateField,
            remarksField,
          },
        },
        // TODO: 乗船期間編集機能追加時にフォームを復活させる
        // 乗船期間情報タブ
        onboardTab: {
          title: "",
          items: {
            //vesselCombo,
            //roleCombo,
            //startDateField,
            //endDateField,
          },
        },

        // TODO: 休暇希望情報編集機能追加時にフォームを復活させる
        // 休暇希望情報タブ
        dayOffRequestTab: {
          title: "",
          items: {
            startDateField,
            endDateField,
            priorityField,
            remarksField,
          },
        },
      },
    };
  };

  const handleBeforeTaskEditShow = ({ editor, taskRecord }) => {
    let title = "乗船期間情報";
    if (taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.ASHORE) {
      title = "下船期間情報";
    } else if (
      taskRecord.event_type === C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST
    ) {
      title = "休暇希望";
    }

    editor.title = title;

    // イベントのイベントタイプによってフォームを切り替える
    // 下船期間情報
    editor.widgetMap.offboardTab.hidden =
      taskRecord.event_type !== C.SCHEDULING_EVENT_TYPE.ASHORE;
    // 休暇希望
    editor.widgetMap.dayOffRequestTab.hidden =
      taskRecord.event_type !== C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST;

    // 乗船期間情報
    editor.widgetMap.onboardTab.hidden =
      taskRecord.event_type !== C.SCHEDULING_EVENT_TYPE.VESSEL;
  };

  return {
    buildCustomTaskEdit,
    handleBeforeTaskEditShow,
  };
})();

export default CustomTaskEdit;
